/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-console */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { paymentDetailColumns } from "./data";
import { FinanceHoverIcon } from "../../../../Common/Svgs/FinanceIcon";
import CustomTable from "../../../../Core/Components/CustomTable";
import {
  getFarmerPaymentDetailsKPI,
  getFarmerTripPaymentDetails,
} from "../../../../Redux/APIs/revenueAPI";
import useDebounce from "../../../../Core/hooks/useDebounce";
import { PaymentDetailsKPIData } from "../../PaymentList/data";
import CustomKPI from "../../../../Core/Components/CustomKpi";
import FarmerDetailHeader from "./FarmerDetailHeader";
import { updateRevenue } from "../../../../Redux/Slices/revenue.slice";
import TransactionHistoryDrawer from "./TransactionHistoryDrawer";
import EditCommodityModal from "./EditCommodityModal";
import CustomPagination from "../../../../Core/Components/CustomPagination";

const LOCAL_DEFAULT_LIMIT = 10;

const FarmerDetailScreen = () => {
  const dispatch = useDispatch();

  const {
    selectedPayment,
    farmerTripPaymentDetails,
    farmerPaymentDetailsKPI,
    transactionHistoryVisible,
    editCommodityModal,
  } = useSelector((state) => state.revenue);

  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [filters, setFilters] = useState({
    paymentStatus: [],
    dateRangeStart: "",
    dateRangeEnd: "",
  });

  const debounceSearch = useDebounce(search, 500);

  useEffect(() => {
    const filterObj = {
      receiverId: selectedPayment?.entityId,
      type: selectedPayment?.entityType,
      offset: ((currentPage || 1) - 1) * LOCAL_DEFAULT_LIMIT,
      limit: (currentPage || 1) * LOCAL_DEFAULT_LIMIT,
    };

    if (debounceSearch) filterObj.searchQuery = debounceSearch;

    if (filters.paymentStatus.length)
      filterObj.paymentStatus = filters.paymentStatus;

    if (filters.dateRangeStart !== "" && filters.dateRangeEnd !== "") {
      filterObj.startDate = filters.dateRangeStart;
      filterObj.endDate = filters.dateRangeEnd;
    }

    dispatch(getFarmerTripPaymentDetails(filterObj));
  }, [dispatch, selectedPayment, currentPage, debounceSearch, filters]);

  // fetch farmer payment details kpi
  useEffect(() => {
    dispatch(
      getFarmerPaymentDetailsKPI({
        entityId: selectedPayment?.entityId,
      }),
    );
  }, [dispatch, selectedPayment]);

  return (
    <div className="w-full h-full">
      <div className="w-full bg-background">
        <div className="w-full flex items-center gap-x-6 p-6">
          {PaymentDetailsKPIData(farmerPaymentDetailsKPI).map((item) => (
            <CustomKPI
              key={item.title}
              title={item.title}
              count={item.count}
              countColor={item.countColor}
              background={item.background}
              image={item.icon}
              unit="KSH"
            />
          ))}
        </div>

        <FarmerDetailHeader
          search={search}
          setSearch={setSearch}
          filters={filters}
          setFilters={setFilters}
          setCurrentPage={setCurrentPage}
        />

        <div
          className={`h-[calc(100vh-72px-128px-70px-40px)] ${
            farmerTripPaymentDetails?.result?.length && "overflow-y-scroll"
          }`}
        >
          <CustomTable
            disableScroll
            columns={paymentDetailColumns}
            data={farmerTripPaymentDetails?.result}
            emptyState={
              <FinanceHoverIcon size={16} className="text-dark-grey-text" />
            }
            emptyStateHeight="420px"
            rowClassName="group"
            pagination={{
              pageSize: LOCAL_DEFAULT_LIMIT,
              total: farmerTripPaymentDetails?.totalRecords,
              showSizeChanger: false,
              onChange: (page) => {
                setCurrentPage(page);
              },
              current: currentPage,
              itemRender: (current, type, originalElement) => {
                return (
                  <CustomPagination
                    type={type}
                    current={current}
                    originalElement={originalElement}
                    totalRecords={Number(
                      farmerTripPaymentDetails?.totalRecords || 0,
                    )}
                  />
                );
              },
              // itemRender: (current, type, originalElement) => {
              //   const lastPage =
              //     farmerTripPaymentDetails.totalRecords / current;

              //   if (type === "prev" && current === 0) {
              //     return (
              //       <button
              //         type="button"
              //         className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
              //         style={{
              //           pointerEvents: "none",
              //         }}
              //       >
              //         <ChevronIcon className="stroke-dark-gray" />
              //       </button>
              //     );
              //   }

              //   if (type === "prev" && current > 0) {
              //     return (
              //       <button
              //         type="button"
              //         className="-rotate-180 rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
              //       >
              //         <ChevronIcon className="stroke-dark-gray" />
              //       </button>
              //     );
              //   }

              //   if (type === "next" && lastPage <= 10) {
              //     return (
              //       <button
              //         type="button"
              //         className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
              //         style={{ pointerEvents: "none" }}
              //       >
              //         <ChevronIcon className="stroke-dark-gray" />
              //       </button>
              //     );
              //   }

              //   if (type === "next") {
              //     return (
              //       <button
              //         type="button"
              //         className="rounded-md h-[32px] min-w-[32px] bg-background flex items-center justify-center p-2"
              //       >
              //         <ChevronIcon className="stroke-dark-gray" />
              //       </button>
              //     );
              //   }

              //   return originalElement;
              // },
            }}
          />
        </div>
      </div>

      <TransactionHistoryDrawer
        visible={transactionHistoryVisible}
        onCancel={() =>
          dispatch(
            updateRevenue({
              key: "transactionHistoryVisible",
              value: false,
            }),
          )
        }
      />

      <EditCommodityModal
        visible={editCommodityModal?.visible}
        onCancel={() =>
          dispatch(
            updateRevenue({
              key: "editCommodityModal",
              value: {
                visible: false,
                current: {},
              },
            }),
          )
        }
      />
    </div>
  );
};

export default FarmerDetailScreen;
